import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

interface LeadCaptureContextType {
  isOpen: boolean;
  openLeadForm: (options?: LeadFormOptions) => void;
  closeLeadForm: () => void;
  formOptions: LeadFormOptions;
}

interface LeadFormOptions {
  redirectToWhatsApp?: boolean;
  whatsAppMessage?: string;
  onSuccess?: () => void;
}

const defaultOptions: LeadFormOptions = {
  redirectToWhatsApp: true,
  whatsAppMessage: 'Olá! Gostaria de saber mais sobre a DGenny',
};

const LeadCaptureContext = createContext<LeadCaptureContextType | undefined>(undefined);

export const useLeadCapture = (): LeadCaptureContextType => {
  const context = useContext(LeadCaptureContext);
  if (!context) {
    throw new Error('useLeadCapture must be used within a LeadCaptureProvider');
  }
  return context;
};

interface LeadCaptureProviderProps {
  children: ReactNode;
}

export const LeadCaptureProvider: React.FC<LeadCaptureProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [formOptions, setFormOptions] = useState<LeadFormOptions>(defaultOptions);

  const openLeadForm = useCallback((options?: LeadFormOptions) => {
    // Dispara evento no dataLayer ao abrir o formulário
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'form_open',
      form_name: 'agendar_demo',
    });
    
    setFormOptions({ ...defaultOptions, ...options });
    setIsOpen(true);
  }, []);

  const closeLeadForm = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <LeadCaptureContext.Provider
      value={{
        isOpen,
        openLeadForm,
        closeLeadForm,
        formOptions,
      }}
    >
      {children}
    </LeadCaptureContext.Provider>
  );
};

export default LeadCaptureProvider;
